// extracted by mini-css-extract-plugin
module.exports = {"container":"label-text_container__2kI2F","label":"label-text_label__1b5T8","text":"label-text_text__1Rp8R","labelTextDivider":"label-text_labelTextDivider__3MeSs"};